import React from "react";
import styles from "./Nav.module.css";

//Non cancellare gli import "BrowserRouter as Router, Switch, Route", anche se vengono segnati come non utilizzati"
/* eslint-disable-next-line */
import globals from "../../../config/appconfig";
import Icon from "../../icon/Icon";
import Header from "../header/Header";
import { urlMapping } from "../../../config/urlMapping";
import SessioneUtente from "../../../sessionManager/SessioneUtente";
import { withTranslation } from "react-i18next";
import NavbarDropdown from "../../navbarDropdown/NavbarDropdown";
import FilterForm from "../../../layouts/gestioneFocolai/filterForm/FilterForm";
import history from "../../../utils/History";
import {
    MonitoraggioDropdownList,
    SorveglianzaMalattieDropdownList,
    UtilitaDropdownList,
    UtilitaHivDropdownList,
    SegnalazioniHivDropDownList,
    ManualiDropdownList
} from "../../../config/menuConfig";
import Utils from "../../../utils/Utils";
import RicercaNav from "../../../layouts/utilita/ricercaNav/RicercaNav";
import EpatiteNav from "../../../layouts/utilita/reportEpatite/EpatiteNav";
import ExportSegnalazioniNav from "../../../layouts/utilita/exportSegnalazioniNav/ExportSegnalazioniNav";
import StatoInvioPremalNav from "../../../layouts/monitoraggio/statoInvioPremalNav/StatoInvioPremalNav";

class Nav extends React.Component {
    widthBreakdown = globals.appWidthBreakdown;

    state = {
        url: window.location.pathname,
        label: "",
        windowWidth: window.innerWidth, //default renders full navbar
        hamburgerDisplay: "none", //username: "Mario Rossi",
    };

    constructor(props) {
        super(props);
        this.toggleHamburger = this.toggleHamburger.bind(this);
        this.createNav = this.createNav.bind(this);
        this.handleHomeLinkClick = this.handleHomeLinkClick.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        this.setState({
            windowWidth: window.innerWidth,
            hamburgerDisplay: "none",
        });
    };

    componentDidUpdate(nextProps, nextContext) {
        if (nextProps.url !== this.state.url) {
            this.setState({ url: nextProps.url });
        }
    }

    toggleHamburger() {
        let actualDisplay = this.state.hamburgerDisplay;
        let newDisplay;
        if (actualDisplay === "none") {
            newDisplay = "flex";
        } else {
            newDisplay = "none";
        }
        this.setState({ hamburgerDisplay: newDisplay });
    }

    getLogo() {
        try {
            let idUtente = SessioneUtente.getInstance().idUtente;
            let sesso = idUtente.substring(9, 11);
            if (sesso > 40) return globals["app-application-logo-woman"];
            else {
                return globals["app-application-logo-man"];
            }
        } catch (e) {
            return globals["app-application-logo-man"];
        }
    }

    switchForm(value) {
        switch (value) {
            case urlMapping.associaSegnalazioni.path:
                return <FilterForm filtri={this.props.filtri} pathProvenienza={{value}}/>;
            case urlMapping.inserimentoSegnalazioni.path:
                return <FilterForm filtri={this.props.filtri} pathProvenienza={{value}}/>;
            case urlMapping.invioSchedeSpeciali.path:
                return <FilterForm filtri={this.props.filtri} pathProvenienza={{value}}/>;
            case urlMapping.integrazioniLIS.path:
                return <FilterForm filtri={this.props.filtri} pathProvenienza={{value}}/>;       
            case urlMapping.segnalazioniDaLIS.path:
                return <FilterForm filtri={this.props.filtri} pathProvenienza={{value}}/>;    
            case urlMapping.esitoTBC.path:
                return <FilterForm filtri={this.props.filtri} pathProvenienza={{value}}/>;
            case urlMapping.statoInvioPremal.path:
                return <StatoInvioPremalNav filtri={this.props.filtri} pathProvenienza={{value}}/>;
            case urlMapping.exportSegnalazioni.path:
                return <ExportSegnalazioniNav filtri={this.props.filtri} />;
            case urlMapping.reportStatistici.path:
                return <RicercaNav filtri={this.props.filtri} />;
            case urlMapping.reportEpatite.path:
                return <EpatiteNav filtri={this.props.filtri} />;
            default:
                return null;
        }
    }

    selectDropDown(label, tipoNav) {
        let dropdown;
        if (label === "PageTitles.sor_malattie") {
            dropdown = (
                <NavbarDropdown
                    toggleHamburger={
                        tipoNav === 2 ? this.toggleHamburger : this.handleResize
                    }
                    elements={SorveglianzaMalattieDropdownList}
                    id={"sorveglianzaMalattia"}
                />
            );
        } else if (label === "PageTitles.monitoraggio") {
            dropdown = (
                <NavbarDropdown
                    toggleHamburger={tipoNav === 2 ? this.toggleHamburger : ""}
                    elements={MonitoraggioDropdownList}
                    id={"monitoraggio"}
                />
            );
        } else if (label === "PageTitles.utilita") {
            dropdown = (
                <NavbarDropdown
                    toggleHamburger={tipoNav === 2 ? this.toggleHamburger : ""}
                    elements={UtilitaDropdownList}
                    id={"utilita"}
                />
            );
        } else if (label === "PageTitles.sorveglianza_hiv") {
            dropdown = (
                <NavbarDropdown
                    toggleHamburger={
                        tipoNav === 2 ? this.toggleHamburger : this.handleResize
                    }
                    elements={SegnalazioniHivDropDownList}
                    id={"segnalazioniHiv"}
                />
            );
        } else if (label === "PageTitles.utilita_hiv") {
            dropdown = (
                <NavbarDropdown
                    toggleHamburger={
                        tipoNav === 2 ? this.toggleHamburger : this.handleResize
                    }
                    elements={UtilitaHivDropdownList}
                    id={"utilitaHiv"}
                />
            );
        } else if (label === "PageTitles.manuali") {
            dropdown = (
                <NavbarDropdown
                    toggleHamburger={
                        tipoNav === 2 ? this.toggleHamburger : this.handleResize
                    }
                    elements={ManualiDropdownList}
                    id={"manuali"}
                />
            );
        }

        return dropdown;
    }

    createNav(tipoNav) {
        let links = this.props.navbarLink;
        let campoNav = "";
        const { t } = this.props;
        let nav = [];
        for (let i = 0; i < links.length; i++) {
            if (Utils.checkFunzionalitaByRuolo(links[i].label)) {
                campoNav = (
                    <ul className={styles.noPaddingMargin} key={links[i].label}>
                        <li
                            className={[
                                styles.stylePagineLi,
                                styles.liPagina,
                                links[i].pagine &&
                                links[i].pagine.includes(
                                    window.location.pathname
                                )
                                    ? styles.activePage
                                    : "",
                            ].join(" ")}
                            id={links[i].label}
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <span className={styles.spanCustom}>
                                {t(links[i].label)}
                            </span>
                        </li>
                        {this.selectDropDown(links[i].label, tipoNav)}
                    </ul>
                );
                nav.splice(i, 0, campoNav);
            }
        }
        return nav;
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleHomeLinkClick = () => {
        if (this.state.hamburgerDisplay !== "none") this.toggleHamburger();

        // gestiamo il caso specifico in cui lo user è nel FormHIV
        const alreadyInTheForm =
            history.location.pathname.startsWith("/formHIV");
        if (alreadyInTheForm) {
            history.push({
                pathname: "/formHIV",
                search: "?redirect=/homeHIV",
            });
        } else {
            history.push(this.props.hiv === true ? "/homeHIV" : "/home");
        }
    };

    render() {
        const { t } = this.props; // per internazionalizzazione
        let logo = this.getLogo();
        let path = window.location.pathname.split("/")[1].replace("/", "");
        let page = urlMapping[path];
        let pageLabel = "";

        if (this.props.navLabel && this.props.navLabel.label) {
            pageLabel = this.props.navLabel.label;
        } else {
            page = urlMapping[path];
        }

        let utente = SessioneUtente.getInstance()
            ? "Ciao, " +
              SessioneUtente.getInstance().nomeUtente +
              " " +
              SessioneUtente.getInstance().cognomeUtente
            : "Ciao, Utente ospite";
        if (urlMapping.home) urlMapping.home.label = utente;
        let homeLink = this.props.hiv === true ? "/homeHIV" : "/home";
        let home = (
            <div onClick={this.handleHomeLinkClick}>
                <ul className={styles.noPaddingMargin}>
                    <li
                        className={[
                            styles.stylePagineLi,
                            styles.liPagina,
                            window.location.pathname.includes(homeLink)
                                ? styles.activePage
                                : "",
                        ].join(" ")}
                    >
                        <span className={styles.spanCustom}>
                            {t("PageTitles.home")}
                        </span>
                    </li>
                </ul>
            </div>
        );

        let terzaFascia = (
            <div className={styles.styleTerzaFascia}>
                <Icon
                    path={page && page.logo ? page.logo : this.getLogo()}
                    classes={styles.avatarGrande}
                    alt={page && page.logoAlt ? page.logoAlt : this.getLogo()}
                />
                <h6
                    className={styles.styleAvatarTerzaFascia}
                    style={{
                        width:
                            page &&
                            page.path === urlMapping.associaSegnalazioni.path
                                ? "32%"
                                : [
                                    urlMapping.reportStatistici.path,
                                    urlMapping.statoInvioPremal.path
                                ].includes(page && page.path)
                                ? "18%"
                                : "37%",
                    }}
                >
                    {pageLabel
                        ? t(pageLabel)
                        : page && page.label
                        ? t(page.label)
                        : urlMapping.default.label}
                </h6>
                {page ? (page.path ? this.switchForm(page.path) : null) : null}
            </div>
        );

        let hamburgerButton = (
            <button
                className="navbar-toggler toggler-example float-right"
                type="button"
                onClick={this.toggleHamburger}
            >
                <Icon id="it-burger" />
            </button>
        );

        let hamburgerNav = (
            <div className={styles.navCustom}>
                {home}
                {this.createNav(2)}
            </div>
        );

        let nav = (
            <div className={styles.navCustom}>
                {home}
                {this.createNav(1)}
            </div>
        );

        let profileDiv = (
            <div className={styles.styleProfilo}>
                {window.location.pathname === "/home" ? (
                    <div style={{ paddingTop: "2em" }}>
                        <p className={styles.noPaddingMargin} />
                        <ul className={styles.noPaddingMargin}>
                            <li
                                style={{ overflow: "auto" }}
                                className={styles.styleProfiloLi}
                                id={"dropdownMenuButton"}
                                data-toggle={
                                    this.props.segnalazioni.length === 0
                                        ? null
                                        : "dropdown"
                                }
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <div className={styles.containerCampanella}>
                                    {this.props.segnalazioni.length > 0 ? (
                                        <div>
                                            <Icon
                                                path={
                                                    "img/icons/campana-notifiche.svg"
                                                }
                                                classes={styles.campanellaRossa}
                                                alt={
                                                    globals[
                                                        "app-application-campana-notifiche"
                                                    ]
                                                }
                                            />
                                            <div className={styles.centered}>
                                                {this.props.segnalazioni.length}
                                            </div>
                                        </div>
                                    ) : (
                                        <Icon
                                            path={"img/icons/campana.svg"}
                                            classes={styles.campanellaGrigia}
                                            alt={
                                                globals[
                                                    "app-application-campana"
                                                ]
                                            }
                                        />
                                    )}
                                </div>
                            </li>

                            <NavbarDropdown
                                elements={this.props.segnalazioni}
                                notifica={true}
                            />
                        </ul>
                    </div>
                ) : (
                    ""
                )}
                <div className={styles.avatarPiccoloDiv}>
                    {/*  abilitare solo nel  caso di sessione utente attiva, per recuperare immagine uomo  o donna */}
                    {logo !== undefined ? (
                        <Icon
                            path={logo}
                            classes={styles.avatarPiccolo}
                            alt={globals["app-application-logo-alt"]}
                        />
                    ) : (
                        <Icon
                            path={globals["app-application-logo"]}
                            classes={styles.avatarPiccolo}
                            alt={globals["app-application-logo-alt"]}
                        />
                    )}
                </div>
                <div className={styles.styleNomeInfo}>
                    <p className={styles.noPaddingMargin} />
                    <ul className={styles.noPaddingMargin}>
                        <li
                            style={{ overflow: "auto", minWidth: "110px" }}
                            className={styles.styleProfiloLi}
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <div
                                className={"container"}
                                style={{ display: "contents" }}
                            >
                                <span className={styles.noPaddingMargin_1}>
                                    {SessioneUtente.getInstance()
                                        ? SessioneUtente.getInstance()
                                              .nomeUtente +
                                          " " +
                                          SessioneUtente.getInstance()
                                              .cognomeUtente
                                        : "Utente Ospite"}
                                </span>
                                <p className={styles.noPaddingMargin}>
                                    {t("Navbar.profileTitle")}
                                    <Icon
                                        id={"it-expand"}
                                        classes={
                                            "icon-expand icon icon-sm icon-light d-flex-inline"
                                        }
                                    ></Icon>
                                </p>
                            </div>
                        </li>

                        <NavbarDropdown
                            elements={this.props.profileDropdownList}
                        />
                    </ul>
                </div>
            </div>
        );

        let applicationName = (
            <div className={styles.nomeApplicazione}>
                <p className={[styles.testoNomeApplicazione].join(" ")}>
                    {this.props.hiv === true
                        ? t(globals["app-application-hiv-name"])
                        : t(globals["app-application-name"])}
                </p>
            </div>
        );

        return (
            <>
                <Header />
                <div>
                    <div className={styles.styleSecondFascia}>
                        {(this.state.windowWidth < this.widthBreakdown ||
                            this.state.windowWidth < 1380) &&
                        window.location.pathname !== "/" &&
                        window.location.pathname !== "" &&
                        window.location.pathname !== "/logout-callback" &&
                        window.location.pathname !== "/unauthorized" &&
                        window.location.pathname !== "/login-callback" &&
                        window.location.pathname !== "/login-select"
                            ? hamburgerButton
                            : null}
                        {applicationName}
                        <div className={styles.navInfo}>
                            {this.state.windowWidth >= 1380 &&
                            window.location.pathname !== "/" &&
                            window.location.pathname !== "" &&
                            window.location.pathname !== "/logout-callback" &&
                            window.location.pathname !== "/unauthorized" &&
                            window.location.pathname !== "/login-callback" &&
                            window.location.pathname !== "/login-select"
                                ? nav
                                : null}
                        </div>
                        {window.location.pathname !== "/" &&
                        window.location.pathname !== "" &&
                        window.location.pathname !== "/logout-callback" &&
                        window.location.pathname !== "/unauthorized" &&
                        window.location.pathname !== "/login-callback"
                            ? profileDiv
                            : null}
                    </div>

                    <div
                        className={[styles.styleSecondFascia].join(" ")}
                        style={{ display: this.state.hamburgerDisplay }}
                    >
                        {window.location.pathname !== "/logout-callback"
                            ? hamburgerNav
                            : null}
                    </div>
                    {window.location.pathname !== "/" &&
                    window.location.pathname !== "" &&
                    window.location.pathname !== "/home" &&
                    window.location.pathname !== "/login-callback" &&
                    window.location.pathname !== "/logout" &&
                    window.location.pathname !== "/logout-callback" &&
                    window.location.pathname !== "/unauthorized" &&
                    window.location.pathname !== "/homeHIV" &&
                    window.location.pathname !== "/login-select"
                        ? terzaFascia
                        : null}
                </div>
            </>
        );
    }
}

export default withTranslation("common")(Nav);
